import React from "react";
import "./About.css";
import Banner from "../Banner/Banner";

const About = () => {
  const values = [
    { icon: "💡", title: "Smart design", desc: "Layouts that guide users and support conversions." },
    { icon: "⚡", title: "High performance", desc: "Fast, reliable sites that keep visitors and rankings strong." },
    { icon: "📈", title: "Business growth", desc: "Decisions tied to leads, revenue, and long-term results." },
  ];

  return (
    <section className="aboutv5">
      <div className="av5-wrap">

        <header>
          <span className="av5-tag">About us</span>
          <h1 className="av5-title">
            We build websites that <span>drive real growth</span>
          </h1>
          <p className="av5-sub">
            We combine design, development, and strategy to deliver clear, fast digital experiences that win trust and convert.
          </p>
        </header>

        <section className="av5-hero">
          <div className="card">
            <h2 className="av5-h2">What we do</h2>
            <p className="av5-p">
              We design and build professional websites and digital systems—from strategy and UI to development and ongoing support.
            </p>
            <ul className="av5-list">
              <li>Modern UI and fully responsive</li>
              <li>SEO-ready structure and content</li>
              <li>Scalable, fast-loading builds</li>
            </ul>
          </div>

          <aside className="card">
            <h2 className="av5-h2">Why work with us</h2>
            <ul className="av5-list">
              <li>Transparent communication</li>
              <li>Custom solutions, no templates</li>
              <li>Results-driven approach</li>
            </ul>

            <div className="av5-stats">
              <div className="stat"><div className="k">30+</div><div className="d">projects</div></div>
              <div className="stat"><div className="k">4.9★</div><div className="d">client rating</div></div>
              <div className="stat"><div className="k">&lt;24h</div><div className="d">response time</div></div>
            </div>
          </aside>
        </section>

        <section className="av5-values">
          {values.map(v => (
            <div className="value" key={v.title}>
              <div>{v.icon}</div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </section>

        <section className="av5-cta">
          <div className="card">
            <h2 className="av5-h2">Ready to start?</h2>
            <p className="av5-p">Tell us your goals and we'll outline the best next step.</p>
            <a href="/contact" className="btn btn-primary">Book a call</a>
          </div>

          <div className="card">
            <h2 className="av5-h2">Our services</h2>
            <p className="av5-p">Design, development, SEO, and digital growth—all under one roof.</p>
            <a href="/services" className="btn btn-outline">View services</a>
          </div>
        </section>

      </div>

      <Banner />
    </section>
  );
};

export default About;
